import React, { useState, useContext, useRef } from "react"
import { AiOutlineUpload } from "react-icons/ai"

import { AppContext } from "../context/GlobalContext"

import { getPalette } from "../helpers/palette"
import { addEvent, getImageHTML } from "../helpers/functions"

import TopNav from "../views/TopNav"
import FileUploadUI from "../views/FileUploadUI"
import ColorsContainer from "../views/ColorsContainer"
import Footer from "../views/Footer"

import "../style.css"

function Home() {
  const { setImage, setColors } = useContext(AppContext)

  let [activeClass, setActiveClass] = useState("")
  let [inputURL, setInputURL] = useState("")
  let [error, setError] = useState("")

  const colorsContainer = useRef(null)

  function FileDragHover(e) {
    e.stopPropagation()
    e.preventDefault()
    setActiveClass(activeClass === "" ? "home__input--file-drag-active" : "")
  }

  const FileSelectHandler = (e) => {
    // cancel event and hover styling
    FileDragHover(e)

    // fetch FileList object
    var files = e.target.files || e.dataTransfer.files

    // process all File objects
    for (var i = 0, f; (f = files[i]); i++) {
      if (f.type.substring(0, 5) !== "image") {
        console.log("Unsupported file type: " + f.name)
      } else {
        setImage(f)
        loadImage(f)
        setError(null)
      }
    }
  }

  const scrollToRef = (ref) =>
    window.scrollTo({
      top: ref.current.offsetTop,
      left: 0,
      behavior: "smooth",
    })
  const executeScroll = () => scrollToRef(colorsContainer)

  function loadImage(image) {
    var fr = new FileReader()
    fr.onload = function (e) {
      var imageHTML = getImageHTML(e.target.result)

      var img = imageHTML.getElementsByTagName("img")[0]

      // Must wait for image to load in DOM, not just load from FileReader
      addEvent(img, "load", function () {
        setColors(getPalette(img))
        setImage(img.getAttribute("src"))

        executeScroll()
      })
    }
    fr.readAsDataURL(image)
  }

  async function fetchImage() {
    try {
      if (String(inputURL).trim() === "") {
        throw new Error("URL is empty. Please provide a valid URL")
      }

      const res = await fetch(inputURL)
      const blobFile = await res.blob()
      if (!blobFile.type.includes("image")) {
        throw new Error("Could not fetch the image from URL")
      }

      setImage(blobFile)
      loadImage(blobFile)
      setError(null)
    } catch (error) {
      setError(error.message)
      console.log(error)
    }
  }
  return (
    <>
      <TopNav />
      <div className="home">
        {/* <div className='home__circle'></div> */}
        <div className="home__header">
          <h1 className="home__header--title">
            Wondering how you can fetch colors from an Image as fast as
            possible?
          </h1>
          <p className="home__header--description">
            Our goal is delivering the smallest bit of color from an image in HEX & RGB as
            fast as possible, empowering you to design and build amazing apps faster.
          </p>
        </div>
        <div style={{ marginTop: 30 }} className="home__input">
          <div className="home__input--file-fetch">
            <input
              className="home__input--file-fetch-input"
              type="text"
              placeholder="Enter image URL..."
              value={inputURL}
              onChange={(e) => setInputURL(e.target.value)}
            />
            <button
              className="home__input--file-fetch-button"
              onClick={fetchImage}
            >
              Fetch Image
            </button>
          </div>
          <div className="home__input--file-select">
            <label
              htmlFor="file-select-input"
              className="home__input--file-select-label"
            >
              Upload <AiOutlineUpload style={{ fontSize: 24, marginLeft: 8 }} />
            </label>
            <input
              type="file"
              id="file-select-input"
              name="fileselect[]"
              multiple="multiple"
              className="home__input--file-select-input"
              onChange={FileSelectHandler}
            />
          </div>
        </div>
        {error && <div className="home__error">{error}</div>}
        <div className="home__waves">
          <img
            src={require("../assets/images/wave.svg")}
            className="home__waves--wave home__waves--wave-1"
            alt=""
          />
          <img
            src={require("../assets/images/wave-2.svg")}
            className="home__waves--wave home__waves--wave-2"
            alt=""
          />
        </div>
      </div>
      <FileUploadUI />
      <div ref={colorsContainer}>
        <ColorsContainer />
      </div>

      <div>
        <br /> <br /> <br /> <br />
        <small
          className="colors__title"
          style={{
            marginTop: "90px !important",
            display: "block",
            margin: "0 auto",
          }}
        >
          Delivering colors at the speed of light
        </small>
        <h1 className="colors__title">Trusted by expert creators.</h1>
        <br />
        <a
          href="https://www.producthunt.com/posts/imagehive?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-imagehive"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=231149&theme=dark"
            alt=""
            style={{
              width: 250,
              height: 54,
              display: "block",
              margin: "0 auto",
            }}
            width="250px"
            height="54px"
          />
        </a>
      </div>

      <Footer />
    </>
  )
}

export default Home
